import React from "react";
import moment from "moment";

import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import PageAncestor from "core/common/page/pageAncestor";
import Toolmenu from "core/components/toolmenu/toolmenu";
import mdEntityService from "core/metamodel/mdEntityService";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {IDomainObject, preSave} from "core/form/formUtils";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import "invoice/page/invoiceDetail.less";
import {observer} from "mobx-react";
import {ObservableMap, action} from "mobx";
import uiService from "core/common/service/uiService";
import MdEntity from "core/metamodel/mdEntity";
import {ShipmentRepackaging, SHIPMENTREPACKAGINGSTATUS} from "shipment/shipmentDomain";
import shipmentService from "shipment/shipmentService";
import ShipmentRepackagingForm from "shipment/component/shipmentRepackagingForm";
import {loc} from "core/common/config/locales";



@observer
export default class ShipmentRepackagingDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.shipment;
  static title = loc.i18n`Repackaging`;
  static icon = 'suitcase';
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("ShipmentRepackagingDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['ShipmentRepackaging'], [{entity: 'SHIPMENTREPACKAGINGSTATUS', lov: true}]);

    let shipmentRepackagingPromise: Promise<ShipmentRepackaging>;

    if (routerParams.id === 'new') {
      let shippedTo = (query.partyId) ? {value: query.partyId, label: query.partyLabel} : null;
      shipmentRepackagingPromise = Promise.resolve(new ShipmentRepackaging({
        $new: true,
        shipmentDate: moment().startOf('day'),
        shipmentTime: moment().format("HH:mm"),
        shippedTo
      }));
    } else if (routerParams.id === 'copy') {
      shipmentRepackagingPromise = shipmentService.readShipmentRepackaging(query.copyId, {mode: 'copy'})
        .then( (shipmentRepackagingObject: ShipmentRepackaging) => {
          shipmentRepackagingObject.cleanOnCopy();
          shipmentRepackagingObject.shipmentRepackagingId = undefined;

          return shipmentRepackagingObject;
        });
    } else {
      shipmentRepackagingPromise = shipmentService.readShipmentRepackaging(routerParams.id);
    }


    return Promise.all([metadataPromise, shipmentRepackagingPromise])
      .then(([entityMap, shipmentRepackagingObject]: [ObservableMap<MdEntity>, ShipmentRepackaging]) => {
        shipmentRepackagingObject.$new = !shipmentRepackagingObject.shipmentRepackagingId;

        if (!shipmentRepackagingObject.repackagingStatus) shipmentRepackagingObject.repackagingStatus = entityMap.get("SHIPMENTREPACKAGINGSTATUS").getLovItem(SHIPMENTREPACKAGINGSTATUS.REPACKAGE);

        shipmentService.shipmentRepackagingObject = shipmentRepackagingObject.initAfterRead(routerParams.id === 'new');
      });
  }



  componentWillUnmount() {
    shipmentService.shipmentRepackagingObject = null;
  }



  customValidate = (shipmentRepackagingObject: ShipmentRepackaging) => {
    let errors = [];

    return errors;
  };


  findRootObject() {
    return shipmentService.shipmentRepackagingObject;
  }



  @action onSave = (evt) => {
    console.log('onSave shipmentRepackagingId = %s, $new = %s', shipmentService.shipmentRepackagingObject.shipmentRepackagingId, shipmentService.shipmentRepackagingObject.$new);
    uiService.showToolbarActionFlag();

    let result = preSave(shipmentService.shipmentRepackagingObject, this.customValidate, true);
    if (!result) {
      return;
    }

    shipmentService.saveShipmentRepackaging(shipmentService.shipmentRepackagingObject)
      .then(action("saveShipmentRepackaging-action", (shipmentRepackagingJson: IDomainObject) => {

        let wasNew = shipmentService.shipmentRepackagingObject.cleanAfterSave(shipmentRepackagingJson);

        if(wasNew) {
          this.context.router.replaceWith('shipmentRepackagingDetail', {id:shipmentService.shipmentRepackagingObject.shipmentRepackagingId});
        }
        uiService.hideToolbarActionFlag();
      }), error => {
        shipmentService.shipmentRepackagingObject.$errors = error.getMessages();
      });

  };





  onAdd = (evt) => {
    console.log('onAdd');
    let query = {};
    this.context.router.transitionTo("shipmentRepackagingDetail", {id: 'new'}, query);
  };

  onCopy = (evt) => {
    console.log('onCopy');
    this.context.router.transitionTo("shipmentRepackagingDetail", {id: 'copy'}, {copyId: shipmentService.shipmentRepackagingObject.shipmentRepackagingId});
  };

  @action onDelete = (evt) => {
    console.log('onDelete');

    shipmentService.deleteShipmentRepackaging(shipmentService.shipmentRepackagingObject.shipmentRepackagingId)
      .then(response => {
        this.goBackOrHome();
      }, error => {
        shipmentService.shipmentRepackagingObject.$errors = error.getMessages();
      });
  };






  render() {

    const {
      query,
    } = this.props;

    let shipmentRepackagingObject = shipmentService.shipmentRepackagingObject;
    let shipmentRepackagingEntity = mdEntityService.getEntity('ShipmentRepackaging');

    const propsForCreateForm = {
      dataObject: shipmentRepackagingObject,
      rootObject: shipmentRepackagingObject,
      entity: shipmentRepackagingEntity,
      entities: mdEntityService.entityMap
    };

    console.log('shipmentRepackagingDetail render shipmentRepackagingId = %s, $new = %s', shipmentRepackagingObject.shipmentRepackagingId, shipmentRepackagingObject.$new);



    return (

      <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
        {this._createToolMenu(shipmentRepackagingObject, query.gridLocation)}
        <ErrorComp messages={shipmentRepackagingObject.$errors}/>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>

        <ShipmentRepackagingForm {...propsForCreateForm} />

      </main>
    );
  }


  _createToolMenu(shipmentRepackagingObject: ShipmentRepackaging, gridLocation: string) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1} historize
                entityName="ShipmentRepackaging" entityId={shipmentRepackagingObject.shipmentRepackagingId}>
        <ZzFlatButton onClick={this.onSave} disabled={!shipmentRepackagingObject.$dirty} label={loc.i18n`Save`} permission={shipmentRepackagingObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={shipmentRepackagingObject.$new} label={loc.i18n`New`} permission={PERMISSION.New}/>
        <ZzFlatButton onClick={this.onCopy} disabled={shipmentRepackagingObject.$new} label={loc.i18n`Copy`} permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="ShipmentRepackaging" pageAncestor={this} onClick={this.onDelete} disabled={shipmentRepackagingObject.$new} label={loc.i18n`Delete`} permission={PERMISSION.Delete}/>
      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/shipment/page/shipmentRepackagingDetail.tsx